import React, { useEffect, useState } from 'react'
import moment from "moment";
import style from "css/mypage.module.css";
import { Button, Modal, QRCode } from "antd";
// import axios from "axios";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { CloseOutlined, CopyOutlined, QrcodeOutlined } from '@ant-design/icons';
import CopyToClipboard from 'react-copy-to-clipboard';
import axios from 'axios';
import { closeAlert, openAlert, openConfirm } from "redux/slices/alertSlice";

function MyResDetailPop({ isOpen, scheduleType, data, closePop }) {
    // let today = new Date();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    // const payload = useSelector((state) => state.user);
    const [scheduleinfo, setscheduleinfo] = useState({});
    const [dataload, setdataload] = useState(false);

    const datetimeConverter = (value) => {
        if (i18n.language === "en-US") {
            return moment(value).locale("en").format("MMMM D, YYYY (ddd) - hh:mm A");
        } else {
            return moment(value).locale("ko").format("YYYY-MM-DD (dd) - a hh:mm");
        }
    };

    const getLocation = (parent, child) => {
        return parent !== null && parent !== undefined && parent !== '' ? `${parent} > ${child}` : child;
    }

    useEffect(() => {
        if (scheduleType !== "" && scheduleType === "M") {
            if (data !== "") {
                let config = {
                    params: {
                        SCHEDULE_ID: data,
                    },
                };
                axios.get("/schedule/myscheduledetail", config).then((res) => {
                    if (res.status === 200) {
                        setscheduleinfo(res.data);
                        setdataload(true);
                    }
                });
            }
        }
    }, [data, isOpen, scheduleType]);

    const downloadFile = (params) => {
        axios
            .post("/schedule/downloadFile", params, { responseType: "blob" })
            .then((response) => response.data)
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", params.ORI_FILE_NM);
                document.body.appendChild(link);
                link.click();
            })
            .catch((error) => {
                const obj = {
                    title: t("MESSAGE.NOTIFICATION"),
                    content: t("MESSAGE.ERROR_OCCURRED"),
                    submitEventHandler: () => {
                        dispatch(closeAlert());
                    },
                };
                dispatch(openAlert(obj));
            });
    };

    // QR
    // const [openPopqr, setOpenQrPop] = useState(false);
    // const closeQrPop = () => {
    //     setOpenQrPop(false);
    // };
    return (
        <div className="mypagedetailpopup">
            <Modal
                className={style.detailpopup} //모달 ClassName
                open={isOpen}
                onCancel={closePop}
                footer={null}
                width="460px"
                centered
                closeIcon={
                    <CloseOutlined
                        style={{
                            color: "#121212",
                            border: "1px solid #a4a4a4",
                            borderRadius: "5px",
                            padding: "5px",
                            fontSize: "24px",
                            top: "20px !important",
                            right: "30px !important",
                        }}
                    />
                }
            >
                {/* <Modal
                    centered
                    className={style.qrpop_full} //모달 ClassName
                    open={openPopqr}
                    onCancel={closeQrPop}
                    footer={null}
                    width="auto"
                >
                    <QRCode
                        errorLevel="H"
                        value="https://www.riv-tech.co.kr/neat"
                        icon={process.env.REACT_APP_CLIENT_URL + "neat2.png"}
                        iconSize={130}
                        size={800}
                    />
                    <div
                        style={{ fontSize: "22px", textAlign: "center", marginTop: "5px" }}
                    >
                        MEETING URL : {scheduleinfo.MEETING_URL}
                    </div>
                </Modal> */}
                {scheduleType === "M"
                    ?
                    <div className={style.detailpop_body}>
                        <div className={style.detailpop_header}>
                            {t("LABEL.TITLE.MEETING_DETAILS")}
                        </div>
                        <div className={style.detailpop_title_bar}></div>
                        <div className={style.detailpop_title}>{scheduleinfo.TITLE}</div>
                        <div className={style.detailpop_content}>
                            <div className={style.detailpop_content_line1}>
                                <div className={style.detailpop_content_header}>
                                    {t("LABEL.MEETING_START")}
                                </div>
                                <div className={style.detailpop_content_body}>
                                    {datetimeConverter(scheduleinfo.START_DATETIME)}
                                </div>
                            </div>
                            <div className={style.detailpop_content_line}>
                                <div className={style.detailpop_content_header}>
                                    {t("LABEL.MEETING_END")}
                                </div>
                                <div className={style.detailpop_content_body}>
                                    {datetimeConverter(scheduleinfo.END_DATETIME)}
                                </div>
                            </div>
                            <div className={style.detailpop_content_line}>
                                <div className={style.detailpop_content_header}>
                                    {t("LABEL.MEETING_HOST")}
                                </div>
                                <div className={style.detailpop_content_body}>
                                    {scheduleinfo.EMAIL}
                                </div>
                            </div>
                            <div className={style.detailpop_content_line3}>
                                <div className={style.detailpop_content_header}>
                                    {t("LABEL.MEETING_PLACE")}
                                </div>
                                <div className={style.detailpop_content_body2 + " scrollbar"}>
                                    {dataload ? (
                                        scheduleinfo.ENDPOINTLIST.length > 3 ? (
                                            scheduleinfo.endpointlist
                                                .map((data) => data.ENDPOINT_NM)
                                                .join(", ")
                                        ) : (
                                            <div>{t("LABEL.NO_MEETING_ROOM")}</div>
                                        )
                                    ) : (
                                        <div>{t("LABEL.NO_MEETING_ROOM")}</div>
                                    )}
                                </div>
                            </div>
                            <div className={style.detailpop_content_line3}>
                                <div className={style.detailpop_content_header}>
                                    {t("LABEL.MEETING_PTCP")}
                                </div>
                                <div className={style.detailpop_content_body2 + " scrollbar"}>
                                    {dataload ? (
                                        scheduleinfo.PARTILIST.length > 3 ? (
                                            scheduleinfo.participantlist.map((data, index) => (
                                                <div key={index}>
                                                    {data.MEMBER_NM} {data.EMAIL}
                                                </div>
                                            ))
                                        ) : (
                                            <div>{t("LABEL.NO_MEETING_PTCP")}</div>
                                        )
                                    ) : (
                                        <div>{t("LABEL.NO_MEETING_PTCP")}</div>
                                    )}
                                </div>
                            </div>

                            <div className={style.detailpop_content_line}>
                                <div className={style.detailpop_content_header}>
                                    {t("LABEL.ATTACHMENT")}
                                </div>
                                <div className={style.detailpop_content_body2 + " scrollbar"}>
                                    {dataload ? (
                                        scheduleinfo.FILE_INFO.length > 3 ? (
                                            (scheduleinfo.attachmentlist || []).map((data, index) => (
                                                <div key={index}>
                                                    <span
                                                        onClick={() => downloadFile(data)}
                                                        className={style.detailpop_content_aTag}
                                                    >
                                                        {data.ORI_FILE_NM}
                                                    </span>
                                                </div>
                                            ))
                                        ) : (
                                            <div>{t("LABEL.NO_ATTACHMENT")}</div>
                                        )
                                    ) : (
                                        <div>{t("LABEL.NO_ATTACHMENT")}</div>
                                    )}
                                </div>
                            </div>

                            <div className={style.detailpop_content_line1}>
                                <div className={style.detailpop_content_header}>
                                    {t("LABEL.MEETING_CONTENT")}
                                </div>
                                <div className={style.detailpop_content_body}>
                                    {scheduleinfo.CONTENTS}
                                </div>
                            </div>
                            {/* <div className={style.detailpop_content_line2}>
                            <div className={style.detailpop_content_header_button_area}>
                                {t("LABEL.MEETING_LINK")}
                            </div>
                            <div
                                className={style.detailpop_content_body}
                                style={{ gap: "5px" }}
                            >
                                <CopyToClipboard
                                    className={style.detailpop_content_button + " cursor"}
                                    text={scheduleinfo.MEETING_URL}
                                    onCopy={() => {
                                        const obj = {
                                            title: t("MESSAGE.NOTIFICATION"),
                                            content: t("MESSAGE.COPY_COMPLETE"),
                                            submitEventHandler: () => {
                                                dispatch(closeAlert());
                                            },
                                        };
                                        dispatch(openAlert(obj));
                                        return;
                                    }}
                                >
                                    <div>
                                        {t("BTN.LINK_COPY")}
                                        <CopyOutlined
                                            style={{
                                                marginLeft: "3px",
                                                fontSize: "15px",
                                            }}
                                        />
                                    </div>
                                </CopyToClipboard>
                                <div
                                    className={style.detailpop_content_button + " cursor"}
                                    onClick={() =>
                                        setOpenQrPop(true)
                                    }
                                >
                                    {t("BTN.QR_CODE")}
                                    <QrcodeOutlined
                                        style={{ marginLeft: "3px", fontSize: "15px" }}
                                    />
                                </div>
                            </div>
                        </div> */}
                        </div>
                    </div>
                    :
                    scheduleType === 'H'
                        ?
                        <div className={style.detailpop_body}>
                            <div className={style.detailpop_header}>
                                {t("LABEL.TITLE.HOTDESKING_DETAILS")}
                            </div>
                            <div className={style.detailpop_content} style={{ marginBottom: 0, marginTop: 15 }}>
                                <div className={style.detailpop_content_line}>
                                    <div className={style.detailpop_content_header}>
                                        {t("LABEL.HOTDESK.USER")}
                                    </div>
                                    <div className={style.detailpop_content_body}>
                                        {data.member.name}
                                    </div>
                                </div>
                                <div className={style.detailpop_content_line1}>
                                    <div className={style.detailpop_content_header}>
                                        {t("LABEL.HOTDESK.START")}
                                    </div>
                                    <div className={style.detailpop_content_body}>
                                        {datetimeConverter(data.startDttm)}
                                    </div>
                                </div>

                                <div className={style.detailpop_content_line}>
                                    <div className={style.detailpop_content_header}>
                                        {t("LABEL.HOTDESK.END")}
                                    </div>
                                    <div className={style.detailpop_content_body}>
                                        {datetimeConverter(data.endDttm)}
                                    </div>
                                </div>

                                <div className={style.detailpop_content_line1}>
                                    <div className={style.detailpop_content_header}>
                                        {t("LABEL.HOTDESK.LOCATION")}
                                    </div>
                                    <div className={style.detailpop_content_body}>
                                        {getLocation(data.resource.location.departmentTitle, data.resource.location.title)}
                                    </div>
                                </div>
                                <div className={style.detailpop_content_line1}>
                                    <div className={style.detailpop_content_header}>
                                        {t("LABEL.HOTDESK.RESOURCE")}
                                    </div>
                                    <div className={style.detailpop_content_body}>
                                        {data.resource.title}
                                    </div>
                                </div>
                                {/* <div className={style.detailpop_content_line}>
                                    <div className={style.detailpop_content_header}>
                                        좌석 타입
                                    </div>
                                    <div className={style.detailpop_content_body}>
                                        {datetimeConverter(scheduleinfo.END_DATETIME)}
                                    </div>
                                </div> */}

                            </div>
                        </div>
                        :
                        <></>
                }
            </Modal>
        </div>
    )
}

export default MyResDetailPop
